export function getUrlParameter( name ) {
	name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' )
	let regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' )
	let results = regex.exec( location.search )

	return results === null ? '' : decodeURIComponent( results[1].replace( /\+/g, ' ' ) )
}

// https://stackoverflow.com/a/1634841
export function removeURLParameter( parameter ) {
	var url = window.location.href
	var urlparts = url.split( '?' )

	if ( urlparts.length >= 2 ) {
		var prefix = encodeURIComponent( parameter ) + '='
		var pars = urlparts[1].split( /[&;]/g )

		// Reverse iteration as may be destructive.
		for ( var i = pars.length; i-- > 0; ) {
			// Idiom for string.startsWith>
			if ( pars[ i ].lastIndexOf( prefix, 0 ) !== -1 ) {
				pars.splice( i, 1 )
			}
		}

		url = urlparts[0] + ( pars.length > 0 ? '?' + pars.join( '&' ) : '' )
	}

	window.history.replaceState( {}, '', url )
}

export function getHostname( url ) {
    let hostname

    // Remove protocol:
    if ( url.indexOf( '//' ) > -1 ) {
        hostname = url.split( '/' )[2]
    }
    else {
        hostname = url.split( '/' )[0]
    }

    // Remove port number:
    hostname = hostname.split( ':' )[0]

    // Remove "?":
    hostname = hostname.split( '?' )[0]

    return hostname
}

export function getRootDomain( url ) {
    let domain = getHostname( url ),
        splitArr = domain.split( '.' ),
        arrLen = splitArr.length

    // Subdomain?
    if ( arrLen > 2 ) {
        domain = splitArr[ arrLen - 2 ] + '.' + splitArr[ arrLen - 1 ]

        // Check for Country Code Top Level Domain (ccTLD) (i.e. ".me.uk"):
        if ( splitArr[ arrLen - 2 ].length == 2 && splitArr[ arrLen - 1 ].length == 2 ) {
            domain = splitArr[arrLen - 3] + '.' + domain
        }
    }

    return domain
}

export function getLocalPathFromUrl( url ) {
    let re = new RegExp( `^(?:https?:\/\/${siteData.site_domain})(.*)`, 'g' ),
        match = re.exec( url ),
        path = match && match[1] ? match[1] : url
        path = path.replace( siteData.site_base_path, '' )

    return path
}
